import React, { useState, forwardRef,  useEffect } from 'react';
import { NavLink, useParams, useNavigate} from 'react-router-dom';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { Tooltip } from 'react-tooltip';
import DataTable from 'react-data-table-component';
import DatosCabezaFamilia from '../Caracterizacion/DatosCabezaFamilia.jsx';
import apiService from './../../Auth/apiService.jsx';
import SweetAlert2 from 'react-sweetalert2';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es, id } from 'date-fns/locale';
import MenuReincorporados from './MenuReincorporados.jsx';
import { useAuth } from './../../Auth/AuthContext.jsx';
import { BotonBorrar } from "./../Utils/BotonBorrar.jsx";
import SearchForm from './../Utils/Searchform.jsx';
import SeccionPageHeader from './../Utils/SeccionPageHeader.jsx';
import CargandoSpinner from './../Utils/CargandoSpinner.jsx';
import { FaCalendar } from 'react-icons/fa';

registerLocale('es', es);
setDefaultLocale('es');

export default function CrearDerivacionesrei(){
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const { token, user, rol, sedeActual } = useAuth();
    const { idCabezaFamilia } = useParams();
    const { control, handleSubmit, register, setValue, watch, getValues, reset, formState: { errors }} = useForm();
    const { derivacionesFields, append, remove } = useFieldArray({
        control,
        name: 'derivacionesFields'
      });
    const [swalProps, setSwalProps] = useState({});
    const [entidades, setEntidades] = useState([]);
    const [ayudas, setAyudas] = useState([]);
    const [integrantes, setIntegrantes] = useState([]);
    const [sedes, setSedes] = useState([]);
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
      });
    const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className="custom-input" onClick={onClick} onKeyDown={(e) => e.key === 'Enter' && onClick()} ref={ref}>
            <input value={value} readOnly className='widthCalendar'/>
            <FaCalendar size={20} color="black"/>
        </div>
        ));
    const fetchData = async (idCabezaFamilia, rol, user) => {
        const url = '/reincorporados/crearformularioregistroderivacionrei';
        const obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol, userId: user }
        setCargando(true);
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;
            setCabezaFamiliaDatos(result.cabezafamilia);
            if (result.entidades && Array.isArray(result.entidades)) {
                setEntidades(result.entidades);
            } else {
                console.error('Invalid entidades data:', result.entidades);
            }
            if (result.ayudas && Array.isArray(result.ayudas)) {
                setAyudas(result.ayudas);
            } else {
                console.error('Invalid ayudas data:', result.ayudas);
            }
            if (result.integrantesdto && Array.isArray(result.integrantesdto)) {
                setIntegrantes(result.integrantesdto);
            } else {
                console.error('Invalid integrantesdto data:', result.integrantesdto);
            }
            if (result.sedes && Array.isArray(result.sedes)) {
                setSedes(result.sedes);
            } else {
                console.error('Invalid sedes data:', result.sedes);
            }
        })
        .catch(error => {
            Mensaje('Crear formulario', `Hubo un error con la carga de datos con el documento ${idCabezaFamilia} ${error}`);
        })
        .finally(() => {
            setCargando(false);
            setValue('cabIdcabezafamilia', idCabezaFamilia);
        });
    };
    const resetForm = (cleanList) => {
        const fechahoy = new Date();
        fechahoy.setHours(fechahoy.getHours() - 5);
        reset((prevValues) => ({
            ...prevValues,
            sede: sedeActual,
            usrId: user,
            idpersona: idCabezaFamilia,
            ayuda: "",
            entidad: 1,
            fecha: fechahoy,
            cantidad: '1',
            observaciones: "",
            derivacionesFields: cleanList ? [] : prevValues.derivacionesFields,
        }));
    };
    useEffect(() => {
        if (sedes.length > 0 && sedeActual) {
            setValue('sede', sedeActual);
        }
    }, [sedes, sedeActual, setValue]);
    useEffect(() => {
        fetchData(idCabezaFamilia, rol, user).then(() => {
            resetForm();
        });
    }, [idCabezaFamilia, rol, user]);
    const [searchTerm, setSearchTerm] = useState('');
    
    const handleSearch = (event) => {
        event.preventDefault();
        if (searchTerm.trim() !== '') {
            navigate(`/reincorporados/crearderivacionesrei/${searchTerm}`, { replace: true });
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const onSubmit = async (data) => {
        if(integrantes.find((item) => item.per_idpersona === data.idpersona).per_fallecido === 'SI'){
            Mensaje('Registrar atencion', "No se puede registrar atencion a un integrante fallecido");
            return;
        }
        const nombreayuda = ayudas.find((item) => item.id === data.ayuda).ayuAyuda;
        const nombreentidad = entidades.find((item) => item.id === data.entidad).entEntidad;
        const nombreSede = sedes.find((item) => item.id === data.sede).sedNombre;
        append({
            idayuda: data.ayuda, 
            ayuda: nombreayuda, 
            idpersona: data.idpersona, 
            identidad: data.entidad, 
            fecha: data.fecha,
            entidad: nombreentidad, 
            cantidad: data.cantidad, 
            observaciones: data.observaciones,
            sede: nombreSede
        });
        resetForm();
    };
    const GuardarAtenciones = async () => {
        const values = getValues();
        setCargando(true);
        let url;
        url = '/reincorporados/registrarderivacionrei';
        try {
            const response = await apiService.post(url, values, token);
            if(response.status === 200){
                Mensaje('Registrar derivacion', JSON.stringify(response.data));
                resetForm(true);
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar derivacion', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Registrar derivacion', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }

      };
    function Borraratencion (row){
        remove(getValues('derivacionesFields').indexOf(row));
    };
    const columns = [
        {
            name: 'Acciones',
            cell: row => (
                <BotonBorrar Borrar={Borraratencion} row={row} />
            ),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Ayuda', selector: row => row.ayuda, sortable: true, width:'25%' },
        { name: 'Identificación', selector: row => row.idpersona, sortable: true, width: '15%'},
        { name: 'Entidad', selector: row => row.entidad, sortable: true, width: '15%' },
        { name: 'Cantidad', selector: row => row.cantidad, sortable: true, width: '10%' },
        { name: 'Observaciones', selector: row => row.observaciones, sortable: true, width: '55%' }
    ];
    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Registrar derivaci&oacute;n" idCabezaFamilia={idCabezaFamilia} url={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} nombreurl="Grupo familiar" nombreform="Registrar derivacion" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <MenuReincorporados idCabezaFamilia={idCabezaFamilia} />
                    <SearchForm searchTerm={searchTerm} setSearchTerm={setSearchTerm} handleSearch={handleSearch} Cargando={Cargando} />
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-info">
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                <DatosCabezaFamilia datos={CabezaFamiliaDatos} />
                                <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='entidad'>Entidad:</label>
                                            <select id='entidad' {...register('entidad', { required: true })} className='form-control' >
                                                {entidades.map((option, index) => (
                                                <option key={`${option.id}-${index}`} value={option.id}>
                                                {option.entEntidad}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.entidad && <p style={{color: 'red'}}>Seleccione entidad</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='ayuda'>Atenci&oacute;n:</label>
                                            <select id='ayuda' {...register('ayuda', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {ayudas.map((option, index) => (
                                                <option key={`${option.id}-${index}`} value={option.id}>
                                                    {option.ayuAyuda}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.ayuda && <p style={{color: 'red'}}>Seleccione derivacion</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='idpersona'>Integrante:</label>
                                            <select id='idpersona' {...register('idpersona', { required: true })} className='form-control' >
                                                {integrantes.map((option, index) => (
                                                <option key={`${option.per_idpersona}-${index}`} value={option.per_idpersona}>
                                                    {option.par_parentesco} {option.per_idpersona} {option.nombre} {option.per_fallecido === 'SI' ? '(Fallecido)' : ''}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.idpersona && <p style={{color: 'red'}}>Seleccione integrante</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='fecha'>Fecha atenci&oacute;n</label>
                                            <Controller
                                                id="fecha"
                                                control={control}
                                                name="fecha"
                                                render={({ field }) => (
                                                    <DatePicker
                                                    placeholderText="fecha"
                                                    onChange={(date) => field.onChange(date)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={field.value}
                                                    customInput={<CustomInput />}
                                                    locale="es"
                                                    dateFormat="yyyy-MM-dd"
                                                    maxDate={new Date()}
                                                    />
                                                )}
                                            />
                                            {errors.fecha && <p style={{color: 'red'}}>Digite fecha de derivacion</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='cantidad'>Cantidad</label>
                                            <input id='cantidad' className="form-control" 
                                                {...register('cantidad', { required: true })}
                                                placeholder="cantidad"/>
                                            {errors.cantidad && <p style={{color: 'red'}}>Digite cantidad</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='sede'>Sede:</label>
                                            <select id='sede' {...register('sede', { required: true })} className='form-control'>
                                                {sedes.map((option, index) => (
                                                <option key={`${option.id}-${index}`} value={option.id}>
                                                    {option.sedNombre}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.sede && <p style={{color: 'red'}}>Seleccione sede</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="observaciones">Observaciones</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('observaciones', { required: true })}
                                                placeholder="observaciones"
                                            />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <button type="submit" className="btn btn-primary">Agregar</button>
                                    </div>
                                </div>
                                </div>
                                
                            </form>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className="card-body table-responsive p-0">
                                        <DataTable
                                            title="Atenciones"
                                            columns={columns}
                                            data={getValues('derivacionesFields')}    
                                            progressPending={Cargando}
                                            pagination
                                            noDataComponent="No hay datos para mostrar"
                                        /> 
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button type="button" onClick={GuardarAtenciones} className="btn btn-primary">Guardar</button>
                            </div>
                        </div>
                        </div>

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}